<button
    mat-icon-button
    matTooltip="Edit value for a country"
>
    <span class="material-icons">language</span>
</button>
